<template>
  <header :style="{ height: `${headerHeight}px` }"
          :class="[$route.name, companyType]">
    <div class="header">
      <h2 class="samsung"
            v-if="companyType === 'SAMSUNG'">
        <i class="icon logo--samsung"></i>
      </h2>
      <h1>
        <router-link :to="{ name: 'Main' }">
          <i class="icon logo--seeall"
             title="seeall"></i>
          <span>Optical Character Recognition Diagnostic System</span>
        </router-link>
      </h1>
      <div class="meInfo"
           v-if="userData && userData.id">
        <button type="button"
                class="btn"
                @click="$router.push({ name: 'AppGuide' })">Help</button>
        <button type="button"
                @click.stop="onTogglePersonalMenu"
                class="me">
          <span class="haze">Me</span>
        </button>
        <transition name="fade" >
          <div v-if="showPersonalMenu" class="me_etc">
            <router-link :to="{ name: 'MyPage' }"
                         v-if="isValidMember">Profile</router-link>
            <router-link :to="{ name: 'ManageApproval' }"
                         v-if="isAdminUser">Member Management</router-link>
            <router-link :to="{ name: 'SignIn' }"
                         @click.native="onSignOut">Sign Out</router-link>
          </div>
        </transition>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import { companyType } from '@/lib/utils'
import authApi from '@/api/auth'

export default {
  name: 'AppHeader',
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['showPersonalMenu', 'headerHeight']),
    ...mapGetters(['userData', 'isAdminUser']),

    companyType () {
      return companyType
    },
    isValidMember () {
      return this.userData.roleCode === 1 || this.userData.statusCode === 1
    }
  },
  created () {
    if (this.companyType !== '4GRIT') {
      this.setHeaderHeight(91)
    }
  },
  methods: {
    ...mapMutations(['clearUserData', 'setShowPersonalMenu', 'setHeaderHeight']),

    onTogglePersonalMenu () {
      this.setShowPersonalMenu(!this.showPersonalMenu)
    },
    onSignOut () {
      authApi.signOut().then(() => {
        this.clearUserData()
        window.location.replace('/signin')
        // this.$router.replace({ name: 'SignIn' })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
header {
  height: 51px;
  background: #151515;
  box-shadow: 0 12px 38px 0 rgba(0, 0, 0, 0.3);
  border-bottom: 1px solid #292929;
  background-size: auto 350px;
  padding-top: 1px;
  background-repeat: no-repeat;
  -webkit-print-color-adjust: exact !important;
  color-adjust: exact !important;

  @media print {
    border-radius: 6px;
    box-shadow: none;
  }

  &.NotFound {
    border-bottom: 0;
    box-shadow: none;
  }

  &.Main {
    &.SAMSUNG {
      background-image: url(~@/assets/asset--header-samsung.jpg);
      background-position: calc(50% + 170px) 40px;
    }
  }

  &.SignIn {
    height: 0 !important;

    &.SAMSUNG {
      height: 39px !important;
    }
  }

  h1 {
    float: left;
    height: 52px;
    font-size: 19px;
    padding: 0 13px;

    a {
      font-weight: bolder;
      font-size: 30px;
      color: #ec0047;
      line-height: 52px;
    }

    span {
      font-size: 11px;
      font-weight: normal;
      color: #ec0047;
    }
  }

  h2 {
    padding: 0 15px;
    margin-top: -1px;
    height: 40px;
    line-height: 38px;

    &.samsung {
      background: #ffffff;
    }

    @media print {
      border-radius: 4px;
      margin: 5px 6px -5px;
      padding: 0 10px;
    }
  }
}

.meInfo {
  position: relative;
  float: right;
  padding: 12px 15px 0 0;

  @media print {
    display: none;
  }

  .btn {
    display: inline-block;
    box-sizing: border-box;
    height: 30px;
    margin-right: 10px;
    vertical-align: middle;
    line-height: 30px;
    color: #fff;
    font-size: 12px;
  }

  .me {
    display: inline-block;
    position: relative;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    background: url(~@/assets/icon--user.svg) no-repeat left top;
  }

.me_etc {
   position: absolute;
   right: 30px;
   top: 50px;
   z-index: 999;
   width: 200px;
   padding: 15px 15px 10px 10px;
   background: #fff;
   border-radius: 3px;
   box-shadow: 0 10px 10px -12px rgba(0, 0, 0, 0.08);
   border: 1px solid #ddd;

   a {
     display: block;
     height: 30px;
     padding-left: 30px;
     margin-bottom: 5px;
     font-size: 13px;
     line-height: 30px;
     border-radius: 4px;
     background: url(~@/assets/images/ico_meInfo.png) no-repeat 5px -2px;

     &:nth-child(2) {
       background-position: 5px -45px;
     }

     &:nth-child(3) {
       background-position: 5px -90px;
     }

     &:hover,
     &:focus {
       color: #4d627b;
       background-image: url(~@/assets/images/ico_meInfo_over.png);
       background-color: #f2f2f2;
     }

     &.menu_help {
       background: url(~@/assets/images/ico_help.png) no-repeat 5px 5px;
     }
   }
 }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/global/AppHeader.vue